<content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed"
                [preserveAspectRatio]="preserveAspectRatio" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [uniqueKey]="uniqueKey">
  <svg:circle cx="10" cy="20" r="8"/>
</content-loader>
